export enum AuditReportRecourseStateEnum {
  OPEN = 'OPEN',
  BOOKED = 'CLOSED', //TODO When Client decide how to call it then change it accordingly
  RECOURSE = 'RECOURSE',
}
